import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 172 172"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#fff",
      "stroke-width": "10",
      transform: "translate(12 11)"
    }, [
      _createElementVNode("circle", {
        cx: "75",
        cy: "75",
        r: "75"
      }),
      _createElementVNode("path", {
        "stroke-linecap": "square",
        d: "m22.587 22.294 104.3 103.8"
      })
    ], -1)
  ]))]))
}
export default { render: render }